import { LightPostModel } from '../../../shared/data/models/light-post.model';

export interface NewPostState {
  newPost: LightPostModel;
  newPostLoading: boolean;
  newPostError: string;
}

export const initialNewPostState: NewPostState = {
  newPost: null,
  newPostError: '',
  newPostLoading: false
};
